export const setActiveDashboard = (nameRouter, target) => {
    target.dashboard.map((item, index) => {
        if(item.path && !item.subMenu && item.name == nameRouter){
            target.title = item.title;
            target.$store.commit('dataActive', index.toString());
            target.$store.commit('dataBreadcrumb', item.breadcrumb);
            target.$store.commit('dataSearchHeader', item.search);
        }else if(item.subMenu){
            item.subMenu.map((one, key) => {
                if(one.path && one.name == nameRouter){
                    target.title = one.title;
                    if(one.active_same){
                        getActiveSame(index, one.active_same, target);
                    }else{
                        target.$store.commit('dataActive', index + '-' + key);
                    }
                    target.$store.commit('dataBreadcrumb', one.breadcrumb);
                    target.$store.commit('dataSearchHeader', one.search);
                }
            })
        }
    })
}

export const getActiveSame = (index, name, target) => {
    target.dashboard[index].subMenu.map((one, key) => {
        if(one.name === name){
            target.$store.commit('dataActive', index + '-' + key);
        }
    })
}